<template>
    <div>
        <slot
            :form-processing="formProcessing"
            :on-submit="onSubmit"
        />
    </div>
</template>
<script>
import toasts from '@/mixins/toasts';
import { mapActions } from 'vuex';

export default {
    mixins: [
        toasts,
    ],

    props: {
        show: {
            type: [Object, Boolean],
            default: () => ({}),
        },
    },

    data: () => ({
        formProcessing: false,
    }),

    methods: {
        ...mapActions(['updateShow']),

        /**
         * Handle update show
         *
         * @param   {object}  data  Show data to update
         */
        async onSubmit(data) {
            this.formProcessing = true;

            try {
                await this.updateShow({ hash: this.show.hash, newShowData: data });

                this.toastSuccess({
                    message: {
                        title: 'Show Info has been updated',
                    },
                });
            } catch (e) {
                this.toastError({
                    message: {
                        title: 'We coudn\'t update Your show info. Please contact us or try again later.',
                    },
                });
            }

            this.formProcessing = false;
        },
    },
};
</script>
